import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import Icon from './common/icons/Icon';
import ReduxFormInput from './common/forms/ReduxFormInput';
import normalizeCreditCardNumber from './common/forms/normalizers/creditCardNumber';
import normalizeCreditCardCVC from './common/forms/normalizers/creditCardCVC';
import ReduxFormPromoCodeInput from './common/forms/ReduxFormPromoCodeInput';
import plans from './common/plans';
import coachingPlans from './common/coaching-plans';
import numeral from 'numeral';

let combinedPlans = { ...plans, ...coachingPlans };

class SubscribeForm extends Component {
  static propTypes = {
    ...formPropTypes,
    onSubmitPromoCode: PropTypes.func.isRequired,
    onRemovePromoCode: PropTypes.func,
    onChangePlan: PropTypes.func.isRequired,
    promoCode: PropTypes.instanceOf(Map),
    trial: PropTypes.bool,
    plan: PropTypes.string.isRequired,
    onPromoPage: PropTypes.bool,
    history: PropTypes.object.isRequired,
  };

  getDiscountAmount = price => {
    const { promoCode } = this.props;

    if (promoCode.getIn(['data', 'valid'])) {
      return Math.min(
        promoCode.getIn(['data', 'amount_off'])
          ? promoCode.getIn(['data', 'amount_off'])
          : promoCode.getIn(['data', 'percent_off']) / 100 * price,
        price
      );
    }
    return 0;
  };

  // getFormattedPrice = price => `$${(price / 100).toFixed(2)}`;

  getFormattedPrice = price => numeral(price / 100).format('$0,0.00');

  getFormattedDiscountPrice = (plan, discountDuration) => {
    let discountText = null;

    if (discountDuration === 'forever') {
      discountText = (
        <div className="plan-original-price">
          <del>
            <span>
              {this.getFormattedPrice(plan.basePrice)} {plan.suffix}
            </span>
          </del>
        </div>
      );
    } else if (discountDuration === 'once') {
      discountText = (
        <div className="plan-original-price">
          {this.getFormattedPrice(plan.basePrice)} {plan.suffix} thereafter
        </div>
      );
    }

    return discountText;
  };

  renderCheckoutBar() {
    const { onRemovePromoCode, promoCode, plan, onChangePlan } = this.props;
    const discountDuration = promoCode.getIn(['data', 'duration']);
    // const trialPeriodText = this.props.trial ? 'not billed until trial period ends' : '';
    if (this.props.onPromoPage) {
      return (
        <div>
          <div className="checkout-bar">
            <span className="checkout-bar__label">Total</span>
            <span className="checkout-bar__value">
              <span className="checkout-bar__total-value">
                {this.getFormattedPrice(
                  plans['bronzeyearly'].basePrice - this.getDiscountAmount(plans['bronzeyearly'].basePrice)
                )}
                <span className="period">
                  {' '}
                  {discountDuration === 'once' ? `1st ${plans['bronzeyearly'].period}` : plans['bronzeyearly'].suffix}
                </span>
              </span>
              {this.getFormattedDiscountPrice(plans['bronzeyearly'], discountDuration)}
            </span>
          </div>
          {promoCode.getIn(['data', 'id']) && (
            <div className="plan-switcher__promo-applied">
              {discountDuration === 'once' ? 'One-time' : 'Recurring'} promo code{' '}
              <span className="code">{promoCode.getIn(['data', 'id'])}</span> has been applied
              <button onClick={onRemovePromoCode}>Remove</button>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="plan-switcher">
        <h3>Choose your Online Membership Plan</h3>
        <div className="plan-switcher__selector">
          {Object.keys(plans).map(key => (
            <button
              className={`plan-switcher__plan${plan === key ? ' active' : ''}`}
              onClick={onChangePlan.bind(this, key)}
              key={key}
            >
              {plans[key].subtext.length > 0 && (<div className="plan-subtext badge"><div className="save">Save</div><div className="percent">33%</div></div>)}
              <div className="plan-title">
                <Icon icon={plan === key ? 'CheckmarkCircleOutline' : 'CheckmarkCircleOutline'} />
                {plans[key].label}
                <br />
              </div>
              <div className="plan-price">
                {this.getFormattedPrice(plans[key].basePrice - this.getDiscountAmount(plans[key].basePrice))}
                <span className="period">
                  {' '}
                  {discountDuration === 'once' ? `1st ${plans[key].period}` : plans[key].suffix}
                </span>
              </div>
              {this.getFormattedDiscountPrice(plans[key], discountDuration)}
              {/* <div className="plan-info">
                {plan === key ? <div className="plan-button">Selected</div> : <div className="plan-button">Select</div>}
              </div> */}
            </button>
          ))}
          <button
            className={`plan-switcher__plan`}
            // onClick={onChangePlan.bind(this, key)}
            onClick={this.navigateToGiftSubscriptionRoute}
          >
            <div className="plan-title">
              <Icon icon="CheckmarkCircleOutline" />
              Give the Gift of Tathata
              <br />
            </div>
            <div className="plan-price">
              <span className="period" />
            </div>
            <div className="plan-subtext">
              Know someone who loves golf? With a subscription to Tathata, they will have unlimited access to Tathata
              Golf Training Courses (including the All-New 60-Day Training Program), Tathata TV, Video Library, as well
              as other member benefits.
            </div>
            {/* <div className="plan-info">Gift a Subscription</div> */}
          </button>
        </div>
        {promoCode.getIn(['data', 'id']) && (
          <div className="plan-switcher__promo-applied">
            {discountDuration === 'once' ? 'One-time' : 'Recurring'} promo code{' '}
            <span className="code">{promoCode.getIn(['data', 'id'])}</span> has been applied
            <button onClick={onRemovePromoCode}>Remove</button>
          </div>
        )}
      </div>
    );
  }

  getTextForKey(key) {
    if (key === 'gold') {
      return (
        <div className="plan-text">
          In addition to your full online membership, enjoy personalized coaching from Bryan Hepler, the Founder of
          Tathata Golf. You will become one of his personal students and enjoy:<br />
          <br />
          12 swing submittals (1 per month)<br />
          12 online follow-up video calls (1 per month)<br />
          20% discount on all Tathata Golf products, schools, & training services.<br />
          <strong>$3,000 value if bought separately.</strong>
        </div>
      );
    } else {
      return (
        <div className="plan-text">
          In addition to your full Online Membership, enjoy personalized coaching from the Tathata Golf staff. This
          membership includes:<br />
          <br />
          12 swing submittals (1 per month)<br />
          12 online follow-up video calls(1 per month)<br />
          20% discount on all Tathata Golf products, schools, & training services.<br />
          <strong>$3,000 value if bought separately.</strong>
          <br />
          <br />
        </div>
      );
    }
  }

  navigateToGiftSubscriptionRoute = () => {
    this.props.history.push('/gift-subscription');
  };

  renderPriceConfirmation = () => {
    const { promoCode, trial, plan } = this.props;

    let confirmationString = `By selecting Start Subscription, your card will be charged $${((combinedPlans[plan]
      .basePrice -
      this.getDiscountAmount(combinedPlans[plan].basePrice)) /
      100).toFixed(2)}`;

    if (trial) {
      confirmationString += ' once your trial ends.';
    } else if (promoCode.getIn(['data', 'valid']) && promoCode.getIn(['data', 'duration']) !== 'forever') {
      confirmationString += ` for the first ${combinedPlans[plan].period}.`;
    } else {
      confirmationString += '.';
    }

    return <div className="price-confirmation">{confirmationString}</div>;
  };

  render() {
    const { error, submitting, handleSubmit, onSubmit, onSubmitPromoCode, promoCode, trial } = this.props;
    const currentYear = new Date().getFullYear();
    const validYears = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(offset => offset + currentYear);

    return (
      <div className="subscribe__form">
        <div className="credit-card-form">
          {this.renderCheckoutBar()}
          <div className="card-wrapper">
            {/* {!this.props.onPromoPage ? (
              // <GiftAside navigateToGiftSubscriptionRoute={this.navigateToGiftSubscriptionRoute} />
            ) : null} */}
            {/* <div className="payment"> */}
            <h3>Enter your payment information</h3>
            {trial && (
              <p>
                Your credit card will not be charged until your 7-Day Trial period has ended. You may cancel at any
                time.
              </p>
            )}
            <form onSubmit={handleSubmit(onSubmit)}>
              <Field name="name" component={ReduxFormInput} placeholder="Name">
                <input type="text" placeholder="Name" />
              </Field>
              <Field name="email" component={ReduxFormInput} placeholder="Email Address">
                <input type="text" placeholder="Email Address" />
              </Field>
              <Field name="email_confirm" component={ReduxFormInput} placeholder="Confirm Email Address">
                <input type="text" placeholder="Confirm Email Address" />
              </Field>
              <Field name="phone" component={ReduxFormInput} placeholder="Phone Number">
                <input type="text" placeholder="Phone Number" />
              </Field>
              {this.props.onPromoPage ? (
                <Field name="mileage_plus_number" component={ReduxFormInput} placeholder="MileagePlus Number">
                  <input type="text" placeholder="MileagePlus Number" />
                </Field>
              ) : null}
              <Field
                name="number"
                component={ReduxFormInput}
                placeholder="Credit Card"
                normalize={normalizeCreditCardNumber}
              >
                <input type="text" placeholder="Credit Card" />
              </Field>
              <div className="credit-card-form__card-details">
                <Field name="exp_month" component={ReduxFormInput} placeholder="Exp. Month">
                  <select>
                    <option value="">Month</option>
                    <option value="1">1 - January</option>
                    <option value="2">2 - February</option>
                    <option value="3">3 - March</option>
                    <option value="4">4 - April</option>
                    <option value="5">5 - May</option>
                    <option value="6">6 - June</option>
                    <option value="7">7 - July</option>
                    <option value="8">8 - August</option>
                    <option value="9">9 - September</option>
                    <option value="10">10 - October</option>
                    <option value="11">11 - November</option>
                    <option value="12">12 - December</option>
                  </select>
                </Field>
                <Field name="exp_year" component={ReduxFormInput} placeholder="Exp. Year">
                  <select>
                    <option value="" key="year">
                      Year
                    </option>
                    {validYears.map(year => (
                      <option value={year} key={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </Field>
                <Field name="cvc" component={ReduxFormInput} placeholder="CVC" normalize={normalizeCreditCardCVC}>
                  <input type="text" placeholder="CVC" />
                </Field>
              </div>
              <div className="credit-card-form__card-details">
                <Field className="pc-field" name="postal_code" component={ReduxFormInput} placeholder="Postal Code">
                  <input type="text" placeholder="Postal Code" />
                </Field>
                <Field
                  name="promoCode"
                  component={ReduxFormPromoCodeInput}
                  placeholder="Promo Code"
                  action={onSubmitPromoCode}
                  promoCode={promoCode}
                />
              </div>
              {error && <div className="input-validation">{error}</div>}
              <p className="credit-card-form__policy">
                By subscribing to Tathata, you agree to our{' '}
                <a href="https://tathatagolf.com/terms" target="_blank" rel="noopener noreferrer">
                  Terms of Use
                </a>{' '}
                and{' '}
                <a href="https://tathatagolf.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>.
              </p>
              <div>
                <button type="submit" className="button button--large" disabled={submitting}>
                  Start Subscription
                </button>
              </div>
            </form>
            {this.renderPriceConfirmation()}
          </div>
        </div>
      </div>
      // </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = 'Name is required.';
  }
  if (!values.email || !values.email.trim()) {
    errors.email = 'Email is required.';
  }
  if (!values.email_confirm) {
    errors.email_confirm = 'Please confirm your email address.';
  } else if (values.email_confirm !== values.email) {
    errors.email_confirm = 'Email addresses must match.';
  }
  if (!values.mileage_plus_number || !values.mileage_plus_number.trim()) {
    errors.mileage_plus_number = 'MileagePlus Number is required.';
  }
  if (!values.number) {
    errors.number = 'Credit card is required.';
  }
  if (!values.exp_month) {
    errors.exp_month = 'Month is required.';
  }
  if (!values.exp_year) {
    errors.exp_year = 'Year is required.';
  }
  if (!values.cvc) {
    errors.cvc = 'CVC is required.';
  }
  if (!values.postal_code) {
    errors.postal_code = 'Postal Code is required.';
  }
  if (!values.phone) {
    errors.phone = 'Phone number is required.';
  }
  return errors;
};

export default reduxForm({ form: 'subscribeForm', validate })(SubscribeForm);



// WEBPACK FOOTER //
// ./src/SubscribeForm.js